// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { SvgContainer } from 'common/styles/oc-styled-components';

// Component
const UrgentSvg = ({ color, height, margin, width }) => (
  <SvgContainer height={height} margin={margin} width={width}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="36"
      fill={color}
      viewBox="0 0 37 36"
      role="presentation"
    >
      <g fillRule="evenodd">
        <path d="M29.587 35.594H7.647c-2.92 0-5.266-1.132-6.433-3.104-1.17-1.974-1.032-4.573.373-7.134l11.3-20.6C14.326 2.136 16.36.69 18.618.69s4.292 1.445 5.73 4.066l11.3 20.6c1.405 2.56 1.542 5.16.374 7.133-1.167 1.972-3.51 3.104-6.433 3.104zm-10.97-31.41c-.91 0-1.883.82-2.667 2.25l-11.3 20.6c-.8 1.454-.954 2.793-.432 3.677.523.885 1.775 1.393 3.43 1.393h21.94c1.654 0 2.906-.508 3.43-1.392.52-.883.365-2.222-.432-3.673l-11.3-20.603c-.785-1.43-1.757-2.25-2.67-2.25z" />
        <path d="M16.528 26.04c0-1.236.864-2.124 2.102-2.124 1.237 0 2.052.888 2.077 2.125 0 1.213-.817 2.124-2.077 2.124-1.262 0-2.102-.91-2.102-2.123zm.77-3.29l-.536-10.575h3.71L19.96 22.75H17.3z" />
      </g>
    </svg>
  </SvgContainer>
);
UrgentSvg.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
};

export default UrgentSvg;
